import script from "./MostaCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./MostaCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./MostaCheckbox.vue?vue&type=style&index=0&id=a855db8e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a855db8e"]])

export default __exports__